import {
  getAll,
  getPage,
  getDetail,
  exportExcel,
} from '@/api/harddiskreportserv'

export default {
  state: {
    state_HardDiskReport_GetAllResult: null,
    state_HardDiskReport_GetPageResult: null,
    state_HardDiskReport_GetDetailResult: null,
    state_HardDiskReport_ExportExcelResult: null,
  },
  mutations: {
    SET_HARDDISKREPORT_GETALL_RESULT: (state, rst) => {
      state.state_HardDiskReport_GetAllResult = rst;
    },
    SET_HARDDISKREPORT_GETPAGE_RESULT: (state, rst) => {
      state.state_HardDiskReport_GetPageResult = rst;
    },
    SET_HARDDISKREPORT_GETDETAIL_RESULT: (state, rst) => {
      state.state_HardDiskReport_GetDetailResult = rst;
    },
    SET_HARDDISKREPORT_EXPORTEXCEL_RESULT: (state, rst) => {
      state.state_HardDiskReport_ExportExcelResult = rst;
    },
  },
  actions: {
    HardDiskReportServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_HARDDISKREPORT_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_HARDDISKREPORT_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    HardDiskReportServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_HARDDISKREPORT_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_HARDDISKREPORT_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    HardDiskReportServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_HARDDISKREPORT_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_HARDDISKREPORT_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    HardDiskReportServ_ExportExcel({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        exportExcel(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_HARDDISKREPORT_EXPORTEXCEL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_HARDDISKREPORT_EXPORTEXCEL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_HardDiskReport_GetAllResult: state => {
      return state.state_HardDiskReport_GetAllResult;
    },
    get_HardDiskReport_GetPageResult: state => {
      return state.state_HardDiskReport_GetPageResult;
    },
    get_HardDiskReport_GetDetailResult: state => {
      return state.state_HardDiskReport_GetDetailResult;
    },
    get_HardDiskReport_ExportExcelResult: state => {
      return state.state_HardDiskReport_ExportExcelResult;
    },
  }
}